<div id="career-guidance" class="inner-page">
  <div class="container-fluid px-lg-5">

    <h2 class="title">Placement Cell</h2>
    <p class="inner-lead mt-3">
      Shah Satnam Ji Girls' College in Sirsa, believing in the quote by Lao Tzu: "The journey of a thousand miles begins
      with one step", has a dedicated Placement Cell aimed at helping students secure employment and internship
      opportunities. Here are some general functions and activities you might expect from the Placement Cell in such a
      college:
    </p>

    <hr class="divider">

    <ul class="list-styled">
      <li><strong>Career Counseling and Guidance:</strong> Offering career advice and helping students understand their
        strengths, weaknesses, and career interests.</li>
      <li><strong>Training and Development:</strong> Organizing workshops, seminars, and training sessions to improve
        students' soft skills, resume writing, interview preparation, and other essential job-related skills.</li>
      <li><strong>Industry Interaction:</strong> Facilitating interactions between students and industry professionals
        through guest lectures, industry visits, and networking events.</li>
      <li><strong>Internship and Job Opportunities:</strong> Coordinating with various companies and organizations to
        provide students with internships and job opportunities.</li>
      <li><strong>Campus Recruitment:</strong> Organizing on-campus recruitment drives where companies come to the
        college to recruit students for various positions.</li>
      <li><strong>Placement Drives and Job Fairs:</strong> Conduct placement drives and job fairs to provide a platform
        for students to interact with potential employers.</li>
    </ul>

    <hr class="divider">

    <h4 class="section-subtitle">Placement Cell Reports</h4>
    <div class="row g-3 mt-2">
      <div class="col-md-4">
        <a href="/assets/pdf/student-facilities/Placement-Cell-2023-24.pdf" target="_blank"
          class="pdf-download-btn w-100 text-center">
          <i class="fa fa-file-pdf-o me-2"></i>Placement Cell 2023-24
        </a>
      </div>
      <div class="col-md-4">
        <a href="/assets/pdf/student-facilities/Placement-Cell-2022-23.pdf" target="_blank"
          class="pdf-download-btn w-100 text-center">
          <i class="fa fa-file-pdf-o me-2"></i>Placement Cell 2022-23
        </a>
      </div>
      <div class="col-md-4">
        <a href="/assets/pdf/student-facilities/Placement-Cell-2021-22.pdf" target="_blank"
          class="pdf-download-btn w-100 text-center">
          <i class="fa fa-file-pdf-o me-2"></i>Placement Cell 2021-22
        </a>
      </div>
    </div>

  </div>
</div>